export const USER_ID_COOKIE_NAME = 'songwhip.userId';
export const TOKEN_COOKIE_NAME = 'songwhip.token';
export const USER_TYPE_COOKIE_NAME = 'songwhip.userType';
export const USER_BRAND_COOKIE_NAME = 'songwhip.userBrand';
